import React, { useState } from "react";
import "../assets/styles/Education.scss";
import { useNavigate } from "react-router-dom";


interface Item {
  id: number;
  type: "education" | "certificate";
  title: string;
  institutionOrIssuer: string;
  date: string;
  image?: string;
  description?: string;
  link?: string;
}

const itemsData: Item[] = [
  {
    id: 1,
    type: "education",
    title: "Perito en computación",
    institutionOrIssuer: "Fundación Kinal",
    date: "2023 - 2025",
    image: "https://siemprehaciaadelanteguate.com/wp-content/uploads/2021/09/fundacion-kinal-2048x739.png",
    description: "Focused on full stack software development. Includes Networking, Java, SQL, JavaScript, HTML, CSS, React.",
  },
  {
    id: 2,
    type: "certificate",
    title: "CS50 Introduction to Computer Science",
    institutionOrIssuer: "Harvard University",
    date: "2025",
    image: "https://logodownload.org/wp-content/uploads/2021/04/harvard-university-logo-1.png",
    link: "https://certificates.cs50.io/33b85a31-3a8e-4948-9930-59b516591112.pdf?size=letter",
    
  },
  {
    id: 3,
    type: "certificate",
    title: "Blue Team Junior Analyst Pathway",
    institutionOrIssuer: "Security Blue Team",
    date: "2025",
    image: "https://wp.securityblue.team/wp-content/uploads/2020/11/sbtwhitebg-600x445-1-300x223.png",
    link: "https://drive.google.com/file/d/1_5bE4_eqBlRNf_N5Ef5otbg7rB6uHUYV/view"
  },
  {
    id: 3,
    type: "certificate",
    title: "Blue Team Junior Analyst Pathway",
    institutionOrIssuer: "Security Blue Team",
    date: "2025",
    image: "https://wp.securityblue.team/wp-content/uploads/2020/11/sbtwhitebg-600x445-1-300x223.png",
    link: "https://drive.google.com/file/d/1_5bE4_eqBlRNf_N5Ef5otbg7rB6uHUYV/view"
  },
];

const EducationCertificates: React.FC = () => {
  const [showAll] = useState(false);
  const navigate = useNavigate();
  const displayedItems = showAll ? itemsData : itemsData.slice(0, 3);

  return (
    <div className="container" id="education">
        <div id="education-certificates" className="items-container">

        <h1>Education & Certificates</h1>
      <div className="cards-grid">
        {displayedItems.map((item) => (
          <div key={item.id} className="card">
            {item.image && (
              <img src={item.image} alt={item.institutionOrIssuer} className="card-image" />
            )}
            <div className="card-content">
              <h3>{item.title}</h3>
              <h4>{item.institutionOrIssuer}</h4>
              <p className="date">{item.date}</p>
              {item.link && (
                <p>
                  <a href={item.link} target="_blank" rel="noreferrer" className="link">
                    View Certificate
                  </a>
                </p>
              )}
              {item.description && <p style={{ color: 'rgb(39, 40, 34)' }}>{item.description}</p>}
              <p style={{ fontStyle: "italic", color: "#000", fontSize: "0.8rem" }}>
                {item.type === "education" ? "Education" : "Certificate"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {itemsData.length > 3 && (
        <div className="see-more">
          <button onClick={() => navigate('/education')} className="view-all-button">
            {showAll ? "Show Less" : "View All"}
          </button>
        </div>
      )}
    </div>
    </div>   
  );
};

export default EducationCertificates;

